<template>
  <div>
    <div class="row limit-table" style="overflow: hidden">
      <div class="col-9">
        <label for="identifier_name"> Nome da Obra </label>
        <b-form-input
          class="mb-2"
          v-model="construction.identifier_name"
          name="identifier_name"
          id="identifier_name"
        />
        <label for="created_at"> Data de Criação </label>
        <b-form-input
          disabled
          class="mb-2"
          v-model="construction.created_at"
          name="created_at"
          id="created_at"
        />
        <b-button @click="updateConstruction()" variant="success">
          Salvar edições
        </b-button>
      </div>
      <div class="col-3">
        <label for="team" class="text-muted">
          Equipe Vinculada (em breve)
        </label>
        <b-list-group>
          <b-list-group-item style="opacity: 100%" active
            >Equipe 1</b-list-group-item
          >
          <b-list-group-item style="opacity: 75%">Equipe 2</b-list-group-item>
          <b-list-group-item style="opacity: 50%">Equipe 3</b-list-group-item>
          <b-list-group-item style="opacity: 25%">Equipe 4</b-list-group-item>
        </b-list-group>
      </div>
    </div>
    <hr />
    <h2>Posts</h2>
    <div class="row limit-table" style="overflow-x: hidden">
      <table class="table">
        <thead class="letter-orange">
          <tr>
            <th scope="col">Título</th>
            <th scope="col">Quantidade de Comentários</th>
            <th scope="col">Data de Postagem</th>
            <th scope="col">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="post in construction.posts" v-bind:key="post.id">
            <th scope="row">
              {{ post.title }}
            </th>
            <td>
              {{ post.comments_count }}
            </td>
            <td>
              {{ post.created_at }}
            </td>
            <td>
              <div @click="viewPost(post.id)" class="btn btn-warning mr-1">
                <i class="fas fa-eye" aria-label="Ver ou Editar"></i>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import PostCard from '../../../components/Journal/Posts/PostCard.vue';
import makeToast from '../../../mixins/makeToast';

export default {
  name: 'journal',
  mixins: [makeToast],
  data() {
    return {
      construction: {},
    };
  },
  computed: {
    ...mapState(['token', 'dadosUsuario']),
    ...mapGetters('journal', ['setConstructions']),
  },
  props: ['id'],
  created() {
    this.getConstructionByID({
      userId: this.dadosUsuario.id,
      constructionId: this.id,
    })
      .then((response) => {
        console.log(response);
        this.construction = response.data.data;
      })
      .catch((error) => {
        console.log(error);
        this.makeToast(
          'Oopss!',
          'Não foi possivel carregar esta obra!',
          'danger'
        );
      });
  },
  methods: {
    ...mapActions('journal', ['getConstructionByID', 'updateConstructionByID']),
    updateConstruction() {
      this.updateConstructionByID({
        userId: this.dadosUsuario.id,
        constructionId: this.construction.id,
        data: this.construction,
      })
        .then((response) => {
          this.makeToast(
            'Sucesso!',
            'Construção atualizada com sucesso!',
            'success'
          );
        })
        .catch((error) => {
          this.makeToast('Oopss!', error.response.data.message, 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    viewPost(postId) {
      const { id } = this;
      this.$router.push({
        name: 'journal-view-edit-post',
        params: { id, postId },
      });
    },
  },
};
</script>

<style scoped>
.border-radius {
  border-radius: 8px;
}

.no-text-decoration:hover {
  color: var(--orange-primary);
  text-decoration: none;
}

.table td,
.table th {
  vertical-align: middle;
}
</style>
